import styled from 'styled-components'

export const HeaderDetailsStyle = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    max-width: 68%;
    min-width: 1536px;
    margin: 0 auto;

    .headerDetailsUrl {
        flex: 1;
        justify-content: flex-start;
        align-items: center;
        display: flex;
        gap: 5px;

        > span {
            font-size: 16px;
            color: #343A40;
            font-weight: 500;
            line-height: 1.5;
        }

        .divTypography {
            color: #343A40;
            font-size: 16px;
            font-weight: bold;
        }

        .linkHome {
            font-size: 16px;
            font-weight: 500;
        }
    }

    /* sm */
    @media (min-width: 600px) and (max-width: 768px) {
      max-width: 100%;

        .headerDetailsUrl {

            > span {
                font-size: 12px;
            }

            .divTypography {
                font-size: 12px;
            }

            .linkHome {
                font-size: 12px;
            }
        }
    }

    /* md */
    @media (min-width: 768px) and (max-width: 1025px) {
      max-width: 77%;
      min-width: 768px;
    }

    /* lg */
    @media (min-width: 1025px) and (max-width: 1280px) {
        max-width: 70%;
        min-width: 1025px;
    }

    /* xl */
    @media (min-width: 1280px) and (max-width: 1536px) { 
        max-width: 85%;
        min-width: 1280px;
    }

    /* 2xl */
    @media (min-width: 1536px) { 
        min-width: 1350px;
    }

`
export const ActionWhatsAppStyle = styled.div`
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    display: flex;
`
export const ActionHelperTypeStyle = styled.div`
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    display: flex;
`
export const ActionReturnStyle = styled.div`
    width: 150px;
    justify-content: center;
    display: flex;
    margin: auto;

    a {

        display: flex;
        text-transform: none;
        font-size: 14px;
        background-color: rgb(233, 236, 239);
        border-radius: 8px;
        border-width: 0px;
        color: rgb(73, 80, 87);
        font-weight: 500;
        font-family: "Open Sans", sans-serif;
        text-decoration: none;
        height: 100%;
        line-height: normal;

        img {
            width: 16px;
            height: 16px;
        }

    }
`
export const HelpPageCurrentStyle = styled.div`
    width: 50px;
    justify-content: center; 
    display: flex;
    
    .labelAjuda {
        color: #8C2458;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
    }
`
export const ActionMenuIntegracaoStyle = styled.div`
    height: 35px;
    width: 165px;
    margin: auto 5px;
    display: flex;

    button {
        text-transform: none;
        font-size: 14px;
        background-color: rgb(73, 80, 87) !important;
        border-radius: 8px;
        color: rgb(255, 255, 255) !important;
        font-weight: 500;
        font-family: "Open Sans", sans-serif;
        text-decoration: none;
        height: 100%;
        line-height: normal;
        width: 100%;
    }
`
